"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SkjemaGruppeFeilContext = void 0;
const PT = __importStar(require("prop-types"));
const React = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const nav_frontend_js_utils_1 = require("nav-frontend-js-utils");
const skjemaelement_feilmelding_1 = __importDefault(require("./skjemaelement-feilmelding"));
require("nav-frontend-skjema-style");
const cls = (className) => (0, classnames_1.default)("skjemagruppe", className);
exports.SkjemaGruppeFeilContext = React.createContext({});
/**
 * Fieldset
 */
class SkjemaGruppe extends React.Component {
    render() {
        const _a = this.props, { children, className, feil, legend, description, tag = "fieldset", feilmeldingId = (0, nav_frontend_js_utils_1.guid)(), utenFeilPropagering } = _a, other = __rest(_a, ["children", "className", "feil", "legend", "description", "tag", "feilmeldingId", "utenFeilPropagering"]);
        const descriptionId = description ? (0, nav_frontend_js_utils_1.guid)() : undefined;
        const childrenWithContext = (React.createElement(exports.SkjemaGruppeFeilContext.Provider, { value: { feil, feilmeldingId } }, children));
        const content = (React.createElement(React.Fragment, null,
            legend && React.createElement("legend", { className: "skjemagruppe__legend" }, legend),
            description && (React.createElement("div", { className: "skjemagruppe__description", id: descriptionId }, description)),
            utenFeilPropagering ? children : childrenWithContext,
            React.createElement(skjemaelement_feilmelding_1.default, { id: feilmeldingId }, typeof feil !== "boolean" && feil)));
        return React.createElement(tag, Object.assign({ className: cls(className), "aria-invalid": !!feil, "aria-errormessage": feil ? feilmeldingId : undefined, "aria-describedby": descriptionId }, other), content);
    }
}
SkjemaGruppe.propTypes = {
    /**
     * En eller flere children, oftest en eller flere .skjemaelement
     */
    children: PT.oneOfType([PT.arrayOf(PT.node), PT.node]).isRequired,
    /**
     * ClassName
     */
    className: PT.string,
    /**
     * Bestemmer hvilken HTML-tag som skal brukes
     */
    tag: PT.string,
    /**
     * legend for skjemagruppen
     */
    legend: PT.node,
    /**
     * Ekstrainformasjon under legend/tittel
     */
    description: PT.node,
    /**
     * Feilmelding
     */
    feil: PT.oneOfType([PT.node, PT.bool]),
    /**
     * Feilmeldings id
     */
    feilmeldingId: PT.string,
    /**
     * Option om man skal propagere feil til children
     */
    utenFeilPropagering: PT.bool,
};
SkjemaGruppe.defaultProps = {
    className: undefined,
    feil: undefined,
    tag: "fieldset",
    utenFeilPropagering: undefined,
};
exports.default = SkjemaGruppe;
